import { Box, Select, Option, Typography } from "@mui/joy";
import { useEffect, useState } from "react";
import { Layers } from "lucide-react";

interface ITearOff {
    value: string | null;
    onChange: (value: string) => void;
    loading?: boolean;
}
export function TearOff(props: ITearOff) {
    const { value, onChange, loading } = { ...props };
    const [tearOff, setTearOff] = useState<string | null>(null);

    const handleUpdate = (event: any, newValue: string | null) => {
        if (loading) return;
        const selectedValue = newValue || "";
        setTearOff(selectedValue);
        onChange(selectedValue);
    };

    useEffect(() => {
        if (value) {
            setTearOff(value);
        }
    }, [value]);

    return (
        <Box flex={1}>
            <Typography level="body-sm" sx={{ fontWeight: "md", mb: 0.5 }}>
                Tear off Layers
            </Typography>

            <Select
                placeholder="Select tear off layer"
                value={tearOff}
                onChange={handleUpdate}
                disabled={loading}
                startDecorator={<Layers size={16} />}
                slotProps={{ listbox: { sx: { zIndex: 10001 } } }}
            >
                {tearOffLayers.map((layer) => (
                    <Option key={layer.label} value={layer.label}>
                        {layer.description}
                    </Option>
                ))}
            </Select>
        </Box>
    );
}

const tearOffLayers = [
    { label: "no tear off", description: "no tear off" },
    { label: "1st layer", description: "1st layer" },
    { label: "2nd layer", description: "2nd layer" },
    { label: "3rd layer", description: "3rd layer" },
    { label: "4th layer", description: "4th layer" },
    { label: "5th layer", description: "5th layer" },
];
